import { render, staticRenderFns } from "./add.vue?vue&type=template&id=32a765ce&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=32a765ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a765ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a765ce')) {
      api.createRecord('32a765ce', component.options)
    } else {
      api.reload('32a765ce', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=32a765ce&scoped=true&", function () {
      api.rerender('32a765ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/announcement/components/add.vue"
export default component.exports